import App from '@modules/husleie-framework/src/static-classes/App.class.js';
import type {
  UpsellAPIInterface,
  OpportunitiesGet,
  OpportunitiesGetResponse,
  /* Electricity */
  ElectricityProviderDataGet,
  ElectricityProviderDataGetResponse,
  UpsellElectricityCreate,
  UpsellElectricityCreateResponse,
  UpsellElectricityGet,
  UpsellElectricityGetResponse,
  /* Deposit Subscription */
  DepositSubscriptionCreate,
  DepositSubscriptionCreateResponse,
  DepositSubscriptionGetDetails,
  DepositSubscriptionGetDetailsResponse,
  DepositSubscriptionGet,
  DepositSubscriptionGetResponse,
  CreditCheckGet,
  CreditCheckGetResponse,
  /* Deposit Account */
  DepositAccountGetDetails,
  DepositAccountGetDetailsResponse,
  DepositAccountUpdateKYC,
  DepositAccountUpdateKYCResponse,
  DepositAccountGet,
  DepositAccountGetResponse,
  /* Security Deposit */
  SecurityDepositGet,
  SecurityDepositGetReponse,
  SecurityDepositGetDetails,
  SecurityDepositGetDetailsResponse,
  SecurityDepositUpdateKYC,
  SecurityDepositUpdateKYCResponse,
  SecurityDepositGetSigningURL,
  SecurityDepositGetSigningURLResponse,
  /* Tenancy Subscription */
  TenancySubscriptionGet,
  TenancySubscriptionGetResponse,
  TenancySubscriptionGetDetails,
  TenancySubscriptionGetDetailsResponse,
  TenancySubscriptionCreate,
  TenancySubscriptionCreateResponse,
} from '@modules/store/upsell/types/UpsellAPI.interface';
import {
  DepositAccountGetSigningURL,
  DepositAccountGetSigningURLResponse,
} from '@modules/store/upsell/types/UpsellAPI.interface';
import APIMocked from './index.mock-api';
import APIReal from './index.real-api';

export default class API implements UpsellAPIInterface {
  private readonly api: any;

  constructor() {
    this.api = App.isMockedAPI() ? new APIMocked() : new APIReal();
  }

  /* Base */

  getOpportunities(get: OpportunitiesGet): Promise<OpportunitiesGetResponse> {
    return this.api.getOpportunities(get);
  }

  getCreditCheck(get: CreditCheckGet): Promise<CreditCheckGetResponse> {
    return this.api.getCreditCheck(get);
  }

  /* Electricity */

  getElectricityProviderData(get: ElectricityProviderDataGet): Promise<ElectricityProviderDataGetResponse> {
    return this.api.getElectricityProviderData(get);
  }

  getElectricity(get: UpsellElectricityGet): Promise<null | UpsellElectricityGetResponse> {
    return this.api.getElectricity(get);
  }

  createElectricity(create: UpsellElectricityCreate): Promise<UpsellElectricityCreateResponse> {
    return this.api.createElectricity(create);
  }

  /* DepositSubscription */

  getDepositSubscriptionDetails(get: DepositSubscriptionGetDetails): Promise<DepositSubscriptionGetDetailsResponse> {
    return this.api.getDepositSubscriptionDetails(get);
  }

  createDepositSubscription(create: DepositSubscriptionCreate): Promise<DepositSubscriptionCreateResponse> {
    return this.api.createDepositSubscription(create);
  }

  getDepositSubscription(get: DepositSubscriptionGet): Promise<DepositSubscriptionGetResponse> {
    return this.api.getDepositSubscription(get);
  }

  /* Deposit Account */

  getDepositAccountDetails(get: DepositAccountGetDetails): Promise<DepositAccountGetDetailsResponse> {
    return this.api.getDepositAccountDetails(get);
  }
  updateDepositAccountKYC(update: DepositAccountUpdateKYC): Promise<DepositAccountUpdateKYCResponse> {
    return this.api.updateDepositAccountKYC(update);
  }
  getDepositAccountSigningURL(get: DepositAccountGetSigningURL): Promise<DepositAccountGetSigningURLResponse> {
    return this.api.getDepositAccountSigningURL(get);
  }
  getDepositAccountLegacy(get: DepositAccountGet): Promise<DepositAccountGetResponse> {
    return this.api.getDepositAccountLegacy(get);
  }
  getDepositAccount(get: DepositAccountGet): Promise<DepositAccountGetResponse> {
    return this.api.getDepositAccount(get);
  }

  /* Security Deposit */

  getSecurityDeposit(get: SecurityDepositGet): Promise<SecurityDepositGetReponse> {
    return this.api.getSecurityDeposit(get);
  }
  getSecurityDepositDetails(get: SecurityDepositGetDetails): Promise<SecurityDepositGetDetailsResponse> {
    return this.api.getSecurityDepositDetails(get);
  }
  updateSecurityDepositKYC(update: SecurityDepositUpdateKYC): Promise<SecurityDepositUpdateKYCResponse> {
    return this.api.updateSecurityDepositKYC(update);
  }
  getSecurityDepositSigningURL(get: SecurityDepositGetSigningURL): Promise<SecurityDepositGetSigningURLResponse> {
    return this.api.getSecurityDepositSigningURL(get);
  }

  /* Tenancy Subscription */

  getTenancySubscription(get: TenancySubscriptionGet): Promise<TenancySubscriptionGetResponse> {
    return this.api.getTenancySubscription(get);
  }

  createTenancySubscription(create: TenancySubscriptionCreate): Promise<TenancySubscriptionCreateResponse> {
    return this.api.createTenancySubscription(create);
  }

  getTenancySubscriptionDetails(get: TenancySubscriptionGetDetails): Promise<TenancySubscriptionGetDetailsResponse> {
    return this.api.getTenancySubscriptionDetails(get);
  }
}
